<template>
  <CRow class="w-100">
    <CCol md="3">
      <div class="d-flex flex-column">
        <h5 class="text-muted">{{selectedTitle}}</h5>
        <MzSelect
          searchable
          :disabled="disableSelect"
          class="w-100"
          :options="availableOptions"
          :value.sync="selectedValue"
          @update:value="(v) => $emit('selection', v)"
        />
      </div>
    </CCol>
    <CCol md="3">
      <slot name="center">
      </slot>
    </CCol>
    <CCol md="6">
      <div>
        <h5 class="text-muted">{{selectedTitle}}</h5>
        <div class="selections-wrapper">
          <div class="selection" v-for="selection in selected">
            <span class="text-muted">
              <slot name="selectionName" :selection="selection">{{selection}}</slot>
            </span>
            <CButton
              class="btn delete-btn"
              color="link"
              @click="$emit('removeSelection', selection)"
            >
              <em class="fa fa-trash"/>
            </CButton>
          </div>
        </div>
      </div>
    </CCol>
  </CRow>
</template>

<script>
export default {
  name: "SelectionRow",
  data() {
    return {
      selectedValue: null,
    }
  },
  watch: {
    selectedValue() {
      if (!this.syncValue) {
        this.selectedValue = null;
      }
    }
  },
  props: {
    selectTitle: String,
    selectedTitle: String,
    selected: [],
    selectOptions: [],
    availableOptions: [],
    disableSelect: Boolean,
    syncValue: {
      type: Boolean,
      default: true,
    }
  }
}
</script>
